// Re-export from shared package with web-compatible sync wrapper for getDistanceUnit
export {
  formatDistance,
  formatDistanceFromMeters,
  formatStepDistance,
  getUnitLabel,
  convertDistance,
} from '@travel-planner/shared/src/utils/distanceUtils';

/**
 * Web-specific synchronous getDistanceUnit.
 * The shared version is async; this preserves the original sync API
 * that existing web components rely on.
 */
export const getDistanceUnit = () => {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      return user.distance_unit || 'miles';
    }
  } catch (error) {
    console.error('Error reading distance unit preference:', error);
  }
  return 'miles';
};

/**
 * Get user's preferred distance radius for itinerary generation.
 * Defaults to 50 if not set.
 */
export const getDistanceRadius = () => {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      return user.distance_radius || 50;
    }
  } catch (error) {
    console.error('Error reading distance radius preference:', error);
  }
  return 50;
};
